export default {
    getterPaymentStatementList: ({ paymentStatement }) => paymentStatement ?? [],
    getterDeductionStatementList: ({ deductionStatement }) => deductionStatement ?? [],
};
